// Contenu de la vitrine publique (passation design, maquette « Accueil LIAmani » 2a).
// Tout ce qui est affirmé ici est vérifié dans docs/BRIEF-VITRINE.md : ne jamais vendre une
// fonctionnalité qui n'a ni écran ni route API.

export type Profil = 'resto' | 'presta';

export interface VitrineModule {
    name: string;
    desc: string;
    tags: Profil[];
}

export const MODULES: VitrineModule[] = [
    { name: 'Planning', desc: 'Grille hebdo, modèles d\'horaires, coût, feuilles de présence.', tags: ['resto'] },
    { name: 'Réservations & acomptes', desc: 'Grandes soirées : tableaux, acomptes, chiffre d\'affaires, alertes.', tags: ['resto'] },
    { name: 'Événementiel', desc: 'Calendrier des privatisations, besoins en renforts, affectation.', tags: ['resto'] },
    { name: 'Suivi privatisation', desc: 'De la demande au devis signé : brief, plaquette, étapes.', tags: ['resto'] },
    { name: 'Menus & Convives', desc: 'Choix des plats par les convives, allergènes, QR de table.', tags: ['resto'] },
    { name: 'Mode terrain', desc: 'Le service en direct côté cuisine : arrivées, plats à partir.', tags: ['resto'] },
    { name: 'Menu & Plats', desc: 'Catalogue de plats et formules, familles d\'allergènes.', tags: ['resto'] },
    { name: 'Agenda des interventions', desc: 'Rendez-vous, tournées, clôture et facturation automatique.', tags: ['presta'] },
    { name: 'Prestations', desc: 'Catalogue, prix, durées, simulateur de devis public.', tags: ['presta'] },
    { name: 'Suivi de prestation & devis', desc: 'Du devis composé jusqu\'au rendez-vous facturé.', tags: ['presta'] },
    { name: 'Abonnements', desc: 'Formules d\'engagement, contrat PDF, signature en ligne.', tags: ['presta'] },
    { name: 'Pub & Newsletter', desc: 'Campagnes email en masse à vos couleurs.', tags: ['presta'] },
    { name: 'Avis clients', desc: 'Collecte après prestation, modération, widget, réalisations.', tags: ['presta'] },
    { name: 'RDV Pro', desc: 'Demande, acceptation, widget de réservation public.', tags: ['resto', 'presta'] },
    { name: 'CRM Contacts', desc: 'Fiches clients, historiques, factures, commandes.', tags: ['resto', 'presta'] },
    { name: 'Fournisseurs', desc: 'Fiches, articles par catégorie, bons de commande.', tags: ['resto', 'presta'] },
    { name: 'Commandes', desc: 'Suivi des commandes, confirmation fournisseur par lien.', tags: ['resto', 'presta'] },
    { name: 'Agences de renfort', desc: 'Partenaires extras, types de postes, personnes envoyées.', tags: ['resto', 'presta'] },
    { name: 'Renforts', desc: 'Suivi des demandes : interne, envoyé, confirmé.', tags: ['resto', 'presta'] },
    { name: 'Factures', desc: 'PDF, TVA, acomptes, envoi, historique, e-facturation.', tags: ['resto', 'presta'] },
    { name: 'Postes & Employés', desc: 'Fiches salariés, postes, documents, taux horaire chiffré.', tags: ['resto', 'presta'] },
    { name: 'Portail salarié', desc: 'Planning, pointage, notes de frais, sondages.', tags: ['resto', 'presta'] },
    { name: 'Demandes de congés', desc: 'Absences, validation, autorisation signée en PDF.', tags: ['resto', 'presta'] },
    { name: 'ToDo', desc: 'Tâches partagées par espace, criticité, échéances.', tags: ['resto', 'presta'] },
    { name: 'Notes', desc: 'Notes rattachées à un événement, un contact, un dossier.', tags: ['resto', 'presta'] },
];

export const PROFILS: { key: Profil | 'all'; label: string }[] = [
    { key: 'resto', label: `Restauration · ${MODULES.filter((m) => m.tags.includes('resto')).length} modules` },
    { key: 'presta', label: `Prestataire de service · ${MODULES.filter((m) => m.tags.includes('presta')).length} modules` },
    { key: 'all', label: 'Tout voir' },
];

export const STATS = [
    { value: String(MODULES.length), label: 'modules activables à la carte' },
    { value: '20', label: 'documents PDF générés pour vous' },
    { value: '4', label: 'niveaux d\'accès, du patron au salarié' },
    { value: '24/7', label: 'réservation en ligne, sans appel' },
];

export const DOCUMENTS = [
    { src: '/vitrine/feuille-de-presence.png', alt: 'Feuille de présence du samedi midi, prête à signer', title: 'La feuille de présence', desc: 'Par service, avec horaires, absences et vos notes surlignées. À imprimer et faire signer.' },
    { src: '/vitrine/renforts.png', alt: 'Affectation des renforts avec le calcul du reste à pourvoir', title: 'Le compte des renforts', desc: 'Besoin de l\'événement moins l\'équipe affectée : ce qu\'il reste à commander s\'affiche seul.' },
    { src: '/vitrine/formulaire-client.png', alt: 'Formulaire reçu par le client, avec options, quantités et total', title: 'Le formulaire client', desc: 'Il choisit ses options, voit son total, verse son acompte. La réponse arrive dans sa fiche.' },
];

export const ACCOMPAGNEMENT = [
    { label: 'Messagerie directe avec l\'équipe', note: 'depuis votre espace' },
    { label: 'Développement sur mesure', note: 'selon votre activité' },
    { label: 'Accès restreint module par module', note: '4 niveaux de compte' },
    { label: 'Salaires et clés chiffrés, audit complet', note: 'journal des actions' },
];
